import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
import { preloadApp } from 'ducks'

function * conditionalFieldsExpireCacheSaga ({ payload }) {
  try {
    yield call(
      fetcher,
      'api/v3/account/expire_conditional_fields',
      {
        method: 'GET'
      }
    )
    yield put(preloadApp())
  } catch (expection) {
    console.error(expection.message)
  }
}

function * watchConditionalFieldsExpireCacheSaga () {
  yield call(takeEvery, 'CONDITIONAL_FIELDS_EXPIRE_CACHE', conditionalFieldsExpireCacheSaga)
}

export default [watchConditionalFieldsExpireCacheSaga()]
